export default "__VITE_ASSET__71fb4de3__"